<template>
  <div class="dialog-wrap">
    <el-dialog
      title="创作中心"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      @close="handleClose"
      append-to-body
    >
      <el-form
        class="form"
        :model="dataForm"
        :rules="rules"
        ref="dataForm"
        label-width="100px"
      >
        <el-form-item
          label="文案标题"
          prop="title"
        >
          <el-input
            v-model="dataForm.title"
            placeholder="请输入文案标题"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="所属选题"
          prop="topic_id"
        >
          <el-select
            v-model="dataForm.topic_id"
            placeholder="请选择所属选题"
            filterable
            clearable
            style="width:360px;"
          >
            <el-option
              v-for="(item,index) in $store.state.mediatopiclist"
              :key="index"
              :label="item.name"
              :value="item.id"
            >
              {{item.name}}
              {{item.account_type_code?`(${formateType_code(item.account_type_code)})`:""}}
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="预发日期"
          prop="pre_pub_time"
        >
          <el-date-picker
            v-model="dataForm.pre_pub_time"
            type="datetime"
            placeholder="请选择日期时间"
            style="width:100%"
            clearable
            value-format="timestamp"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            v-model="dataForm.remark"
            type="textarea"
            placeholder="请输入备注"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="作者"
          prop="part_time_name"
        >
          <el-input
            v-model="dataForm.part_time_name"
            placeholder="请输入作者"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="兼职费用"
          prop="part_time_fee"
        >
          <el-input
            v-model="dataForm.part_time_fee"
            placeholder="请输入兼职费用"
          > <template slot="append">元</template></el-input>
        </el-form-item>
        <el-form-item
          label="文案内容"
          prop="download_url"
        >
          <el-upload
            multiple
            :limit="1"
            :on-success="handleSuccess"
            :on-remove="handleRemove"
            :action="imgUploadUrl"
            :file-list="fileList"
          >
            <el-button
              size="small"
              type="primary"
              :disabled="fileList.length==1"
            >点击上传</el-button>
          </el-upload>
        </el-form-item>
        <!--         <el-form-item
          label="文案内容"
          prop="content"
        >
          <UEeditor
            :setDataStr="dataForm.content"
            @change="initDtaForm"
          />
        </el-form-item> -->
      </el-form>

      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="handleClose">取 消</el-button>
        <el-button
          type="primary"
          @click="handleSubmit"
        >确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>


import { mediawritingUpdate, mediawritingOne } from "@/api/select";
import UEeditor from "@/components/UEeditor.vue"
import { imgUploadUrl, uploadHeaders } from "@/config/index";

export default {
  components: {
    UEeditor
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }, content: {
      type: Object,
      default: () => {
        return null
      }
    },
  },
  data() {
    return {
      dialogVisible: this.visible,
      dataForm: {

      },
      imgUploadUrl: imgUploadUrl(),
      fileList: [],
      rules: {
        title: [{ required: true, message: '请输入文案标题', trigger: 'blur' }],
        topic_id: [{ required: true, message: '请选择所属选题', trigger: 'blur' }],
        pre_pub_time: [{ required: true, message: '请选择预发日期', trigger: 'blur' }],
        part_time_name: [{ required: true, message: '请输入作者', trigger: 'blur' }],
        part_time_fee: [{ required: true, message: '请输入兼职费用', trigger: 'blur' },
        { pattern: /^(\d+|\d+\.\d{1,2})$/, message: '输入最多两位小数的数字' }],
        download_url: [{
          required: true,
          validator: (rule, value, callback) => {
            if (!this.fileList.length) {
              callback(new Error('请上传文案内容'))
            } else {
              callback()
            }
          },
        }],
      },

    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
    content(val) {
      if (val) {
        this.fetchDetail()
      }
    }
  },
  methods: {
    fetchDetail() {
      mediawritingOne({ id: this.content.id }).then(res => {
        this.dataForm = res
        try {
          let fileData = JSON.parse(res.download_url)
          this.fileList = [fileData]
        } catch (error) {
          this.fileList = [{
            url: res.download_url,
          }]
        }
      })
    },
    handleSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          let query = {
            id: this.dataForm.id,
            title: this.dataForm.title,
            topic_id: this.dataForm.topic_id,
            pre_pub_time: this.dataForm.pre_pub_time,
            remark: this.dataForm.remark,
            part_time_name: this.dataForm.part_time_name,
            part_time_fee: this.dataForm.part_time_fee,
            download_url: JSON.stringify(this.fileList[0]),

          }
          mediawritingUpdate(query).then(res => {
            this.$message.success(`创建成功`)
            this.$refs['dataForm'].resetFields()
            this.$emit('submit')
            this.handleClose()
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },

    handleClose() {
      this.$emit('close')
    },
    initDtaForm(e) {
      this.dataForm.content = e
    },
    handleRemove(file, fileList) {
      this.fileList = fileList
    },
    handleSuccess(response, file, fileList) {
      this.fileList.push({
        url: response.data.url,
        name: file.raw.name
      })
    },
    formateType_code(val) {
      const type_code = {
        1: "机构",
        2: "课程",
        3: "学科",
        4: "院校",
      };
      return type_code[val] || "";
    },

  }
}
</script>

<style lang="less" scoped>
.tags-wrap {
  .el-tag {
    margin: 4px;
  }
}
</style>
